import React from 'react';
import config from '../config';
import Chip from '@material-ui/core/Chip';
import {getLabel} from "../util";

const RightField = ({ record = {}, source }) => (
        <Chip label={getLabel(record[source], config.permissions)} />
);

export default RightField;